/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
$(document).ready(function() {
    $('.st-atc').on('click', function() {
        // Find the closest sibling with class .Product
        var productSibling = $(this).parent().siblings('.Product');

        // Find the .ProductForm__AddToCart element within this sibling
        var addToCartButton = productSibling.find('.ProductForm__AddToCart');

        // Trigger a click on the found button
        addToCartButton.click();
    });
  $('.st-buy').on('click', function() {
        // Find the closest sibling with class .Product
        var productSibling = $(this).parent().siblings('.Product');

        // Find the .ProductForm__AddToCart element within this sibling
        var addToCartButton = productSibling.find('.shopify-payment-button__button');

        // Trigger a click on the found button
        addToCartButton.click();
    });
});
